import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Chip from "@material-ui/core/Chip"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import { Button, Card } from "reactstrap"
import { Popconfirm } from "antd"
import { Link } from "react-router-dom"
import { handleExample } from "./handleExample"

const ErrorBulletinsItem = props => {
  const [example, setExample] = useState()
  //Chips
  // const [displayedNames, setDisplayedNames] = useState([])
  // const [remainingNames, setRemainingNames] = useState([])
  const [item, setItem] = useState()

  useEffect(() => {
    if (props.item) {
      setItem(props.item)
      // Split target_groups = TRUE
      setExample(handleExample(props.item, true))
    }
  }, [props.item])

  const sendValues = () => {
    props.settingPreview(item.guid)
    props.settingContentLink(item.id)
  }

  const sendValuesEmail = () => {
    props.settingSelectedGuid(props.item.guid)
    props.settingContentLink(props.item.id)
  }
  return (
    <>
      {example && (
        <Card className="shadow-none border p-3 mb-2">
          <div className="d-flex-email">
            <div className="align-self-center overflow-hidden me-auto ms-2">
              <Link to="#" className="d-flex" onClick={() => sendValues()}>
                <div className="h5 font-size-16 text-truncate mb-1 me-2 ">
                  <span className="h6 font-size-14">
                    {props.t(example.title)}
                  </span>
                </div>
                <div className="text-muted me-3">{example.date}</div>
              </Link>
              <div>
                <Chip
                  size="small"
                  key={example.id + "_chip"}
                  className="font-size-11 me-2 mt-2"
                  style={{
                    background: example.color,
                    color: "white",
                  }}
                  //variant="outlined"
                  label={props.t(example.status)}
                />
              </div>
              <div style={{ textOverflow: "ellipsis" }}>
                {example.targets.map(target => (
                  <Chip
                    size="small"
                    key={target + "_chip"}
                    className="font-size-11 me-2 my-2"
                    label={props.t(target)}
                  />
                ))}
              </div>
            </div>
            <div className="float-end mt-1 d-md-block ">
              <Button
                size="sm"
                color="transparent"
                className="mx-1"
                onClick={() => sendValuesEmail()}
              >
                <i className="bx bx-mail-send text-primary font-size-14"></i>
              </Button>
              <Button
                size="sm"
                color="transparent"
                className="mx-1"
                onClick={() => props.settingSelectedId(props.item.id)}
              >
                <i className="bx bx-edit-alt text-primary font-size-14"></i>
              </Button>
              <Popconfirm
                title={props.t("Confirm action")}
                open={props.deleteConfirm}
                okType="danger"
                okText={props.t("Delete")}
                cancelText={props.t("Cancel")}
                onConfirm={() => {
                  props.deleteRelease(props.item.id)
                  props.setDeleteConfirm(false)
                }}
                onCancel={() => {
                  props.setDeleteConfirm(false)
                }}
              >
                <Button
                  size="sm"
                  color="transparent"
                  className="mx-1"
                  onClick={() => {
                    props.setDeleteConfirm(true)
                  }}
                >
                  <i className="bx bx-trash text-danger font-size-14"></i>
                </Button>
              </Popconfirm>
            </div>
          </div>
        </Card>
      )}
    </>
  )
}

ErrorBulletinsItem.propTypes = {
  t: PropTypes.any,
  item: PropTypes.any,
  settingPreview: PropTypes.any,
  settingSelectedId: PropTypes.any,
  settingSelectedGuid: PropTypes.any,
  deleteConfirm: PropTypes.any,
  setDeleteConfirm: PropTypes.any,
  deleteRelease: PropTypes.any,
  settingContentLink: PropTypes.any,
}

export default withRouter(withTranslation()(ErrorBulletinsItem))
